import { UIButton } from "@/components/ui/button";
import { href } from "@/lib/localized-paths";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useLocale } from "@/app/[lang]/providers/LocaleProvider";
import { useDict } from "@/app/[lang]/providers/DictionaryProvider";
import { MenuId } from "@/lib/enum";
import { HomePage } from "../type/type";

export default function GrowPurpose({ data }: { data: HomePage | undefined }) {
  const router = useRouter();
  const locale = useLocale();
  const dict = useDict();
  const onClickCareer = () => {
    if (data?.grow_cta_url) {
      router.push(data.grow_cta_url);
    } 
  };
  const onClickMagang = () => {
    if (data?.grow_magang_url) {
      router.push(data.grow_magang_url);
    } 
  };
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-0">
      <div className="flex flex-col">
        <div className="flex flex-col ">
          <div className="flex flex-col-reverse gap-8 md:flex-row md:gap-20 md:items-center">
            <div className="flex flex-col gap-6 md:gap-10">
              <h2 className="text-primary-800 font-bold text-3xl md:text-5xl">
                {data?.grow_title}
              </h2>
              <div className="text-secondary text-lg" dangerouslySetInnerHTML={{ __html: data?.grow_desc || dict.homepage?.grow_intro || "Join us to build your career with meaningful purpose and contribute to impactful projects that make a difference." }} />
              <div className="flex flex-wrap gap-4">
                <UIButton className="w-fit text-base md:text-lg px-6 py-3 md:px-10 md:py-5" variant="default" onClick={onClickCareer}>
                  {data?.grow_cta || dict.homepage?.start_journey || "Start Your Journey"}
                </UIButton>
                {(data?.grow_magang_cta || dict.homepage?.magang_cta) && (
                  <UIButton className="w-fit text-base md:text-lg px-6 py-3 md:px-10 md:py-5" variant="default" onClick={onClickMagang}>
                    {data?.grow_magang_cta || dict.homepage?.magang_cta || "Program Magang"}
                  </UIButton>
                )}
              </div>
            </div>
            <img
              src={data?.grow_image}
              alt={data?.grow_image_alt}
              width={540}
              height={440}
              className="h-auto w-full max-w-135 shrink-0 object-contain"
            />
          </div>
        </div>
        <div className="flex flex-col gap-8 mt-10 md:mt-[70px] md:grid md:grid-cols-2 md:gap-x-12 md:gap-y-10">
          {(data?.grow_list || [
            { title: dict.homepage?.meaningful_work || "Meaningful Work", description: dict.homepage?.meaningful_work_desc || "Contribute to projects that positively impact communities and the nation's housing sector." },
            { title: dict.homepage?.career_development || "Career Development", description: dict.homepage?.career_development_desc || "Access continuous learning and growth opportunities to advance your professional journey." },
            { title: dict.homepage?.collaborative_env || "Collaborative Environment", description: dict.homepage?.collaborative_env_desc || "Work alongside passionate professionals in a supportive and innovative workplace." },
            { title: dict.homepage?.values_culture || "Values-Driven Culture", description: dict.homepage?.values_culture_desc || "Be part of an organization committed to integrity, purpose, and making a real difference." },
          ]).map((item, index) => (
            <div key={index} className="flex">
              <span className="text-gray mr-2 w-8 text-right tabular-nums shrink-0">{String(index + 1).padStart(2, '0')}</span>
              <div className={`border-l-2 ${index % 2 === 0 ? 'border-[#FFA100]' : 'border-[#1D73BC]'} pl-5 space-y-1`}>
                <h3 className="text-gray font-bold text-3xl">{item.title}</h3>
                <span className="text-secondary" dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
